import React from "react";
import { Container, Form } from "react-bootstrap";
import "../../styles/Career/CareerJoinUs.scss";
const JoinUs = () => {
  return (
    <Container fluid className="career-join-us-bg">
      <Container className="join-us-container">
        <div className="join-us">Join Us</div>
        <form>
          <div className="row">
            <div className="col-12 col-sm-12 col-md-6 col-lg-6">
              <input
                type="text"
                placeholder="Name"
                className="mb-4 w-100 custom-form-control"
              />
            </div>
            <div className="col-12 col-sm-12 col-md-6 col-lg-6">
              <input
                type="email"
                placeholder="Email"
                className="mb-4 w-100 custom-form-control"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-sm-12 col-md-6 col-lg-6">
              <input
                type="Number"
                placeholder="Phone"
                className="mb-4 w-100 custom-form-control"
              />
            </div>
            <div className="col-12 col-sm-12 col-md-6 col-lg-6">
              <input
                type="file"
                placeholder="Your CV"
                className="w-100 custom-form-control"
              />
            </div>
          </div>
          <button
            variant="primary"
            type="submit"
            className="join-us-apply-button"
          >
            Apply
          </button>
        </form>
      </Container>
    </Container>
  );
};

export default JoinUs;
